import { render } from "./StockGroupList.vue?vue&type=template&id=163b1e2c&scoped=true"
import script from "./StockGroupList.vue?vue&type=script&lang=js"
export * from "./StockGroupList.vue?vue&type=script&lang=js"

import "./StockGroupList.vue?vue&type=style&index=0&id=163b1e2c&scoped=true&lang=css"

import exportComponent from "C:\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Controller\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-163b1e2c"]])

export default __exports__